<template>
  <div>
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="employee" @click="goTo('employee')">
        <a-icon type="double-left" style="margin-right: 5px;" />
        List
      </a-menu-item>
      <a-menu-item key="basicInfoEmployee" @click="goTo('basicInfoEmployee')">
        Information
      </a-menu-item>
      <a-menu-item key="workLeaveEmployee" @click="goTo('workLeaveEmployee')">
        Leave
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: ["Thông tin chung"],
    };
  },
  methods: {
    goTo(name) {
      this.$router.push({ name });
    },
    checkCurrentActive() {
      const pathName = this.$route.name;
      if (pathName) {
        this.current = [pathName];
      }
    },
  },
  created() {
    this.checkCurrentActive();
  },
};
</script>
